import React, { useState, useEffect } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";

export default function EditStaffDialog({ open, onOpenChange, member, onSaved }) {
  const [form, setForm] = useState({ name: "", phone: "", email: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open && member) setForm({ name: member.name || "", phone: member.phone || "", email: member.email || "" });
  }, [open, member]);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.patch(`/users/${member.id}`, form);
      toast.success("Cadastro atualizado!");
      onOpenChange(false);
      onSaved?.();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="edit-staff-dialog">
        <DialogHeader>
          <DialogTitle>Editar cadastro</DialogTitle>
          <DialogDescription>Atualize os dados do membro da equipe.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1.5"><Label>Nome</Label>
            <Input value={form.name} onChange={upd("name")} data-testid="edit-staff-name-input" /></div>
          <div className="space-y-1.5"><Label>Telefone / WhatsApp</Label>
            <Input value={form.phone} onChange={upd("phone")} data-testid="edit-staff-phone-input" /></div>
          <div className="space-y-1.5"><Label>E-mail</Label>
            <Input type="email" value={form.email} onChange={upd("email")} data-testid="edit-staff-email-input" /></div>
          <DialogFooter>
            <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700" disabled={busy} data-testid="submit-edit-staff-button">
              {busy ? "Salvando..." : "Salvar"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
